// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateProduct = product => ({
    product,
    type: actions.UPDATE_PRODUCT_SEARCH_PRODUCT
});



// WEBPACK FOOTER //
// ./src/product/search/action-creators/product.js